import React from "react";
import Icon from "../../assets/Icon";

function InteviewScheduleNavbar() {
  return (
    <div class="relative flex items-center w-full my-2">
      <div class="absolute left-0">
        <Icon type="hire-logo" width="90" height="70" />
      </div>
      <span class="mx-auto font-semibold text-3xl">Maya Demo Scheduler</span>
    </div>
  );
}

export default InteviewScheduleNavbar;
